import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';

@Component({
  selector: 'app-mysettings',
  templateUrl: './mysettings.component.html',
  styleUrls: ['./mysettings.component.css']
})
export class MysettingsComponent implements OnInit {

  constructor(public parent: ManagementComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet) {
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');
   }

   SMTPConfigs:any[];
   SMTPEmails:any[];
   loadingUser:boolean;
   CurrenctSMTP:any;
   ShowDeleteSMTPQuestion:boolean;
   ShowDeleteSMTPEmailQuestion:boolean;
   CurrenctSMTPEmail:any;
   NewSMTPEmail:{[k: string]: any} = {};
   NewSMTP:{[k: string]: any} = {};

  ngOnInit(): void {
    this.GetCompanySMTPConfigs();
  }

  GetCompanySMTPConfigs(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.parent.Company.ID
    };

    this.parent.loading = true;
    this.service.GetCompanySMTPConfigs(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SMTPConfigs = response["SMTPConfigs"];
        this.NewSMTPEmail = null;
        this.NewSMTP = null;
      }

      this.parent.loading = false;
    });

    if(this.SMTPConfigs == null || this.SMTPConfigs.length == 0){
      this.InitializeNewSMTP();
    }
  }

  GetCompanySMTPEmails(SMTPID:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SMTPID:SMTPID
    };

    this.loadingUser = true;

    this.service.GetCompanySMTPEmails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SMTPEmails = response["Emails"];
      }
     
      this.loadingUser = false;
    });
  }

  UpdateUser(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.UpdateUser(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.AddUpdateUserManagementInfo();
      }
   
      this.parent.loading = false;
    });
  }

  InitializeNewSMTP(){
    this.NewSMTP = {};
    this.NewSMTP.ID = 0;
    this.NewSMTP.SMTPServer = "";
    this.NewSMTP.Port = "";
    this.NewSMTP.CompanyID = this.parent.Company.ID;
  }

  AddUpdateUserManagementInfo(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.AddUpdateUserManagementInfo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.parent.User.UserManagementInfo = response["UserManagementInfo"];
        localStorage.setItem('User', JSON.stringify(this.parent.User));
      }
   
      this.parent.loading = false;
    });
  }

}
